// extracted by mini-css-extract-plugin
export default {"cont":"Container_cont__27j7x","innerLayout":"Container_innerLayout__Khqfl"};